import React, { useEffect, useState } from 'react';
import { arrow_tip_dark, blueArrow, DCUnavailable, locationGrey } from '../../assets/images';
import { EmptyListCard, Slots, SpinnerDotted } from '../common/atoms';
import { handleAppError } from '../handlers';
import { dsButtonDisabledPrimary, dsButtonPrimary, dsButtonTextAction, joinButtonClasses } from '../../utils/buttonStyles';

const ChooseProviderModal = ({ packageID, packageType, address, employeeID, employeeName, mobileNumber, changeHandler, createHandler, failureHandler, line1, isdCode }) => {
  const [state, setState] = useState({
    loading: true, address: address, line1: line1, employeeID: employeeID, mobileNumber: mobileNumber, packageID: packageID, packageType: packageType,employeeName: employeeName,isdCode: isdCode,
    benefitType: 'ahc', providers: [], showDates: false, selectedProviderID: null, selectedProvider: null, selectedTime: null, selectedDate: null, disableButton: false
  });

  const [selected, setSelected] = useState(false);

  const [showSlotsFor, setSlotsFor] = useState(-1);

  const setSubState = (newState) => {
    setState(prevState => { return { ...prevState, ...newState } })
  }

  useEffect(() => {
    fetchProviders()
  }, [])

  const fetchProviders = () => {
    let ids = []
    ids.push(state.packageID)

    const params = {
      benefit_type: state.benefitType,
      radius: 50,
      package_ids: ids,
      latitude: state.address.latitude,
      longitude: state.address.longitude,
      pincode: state.address.zip_code
    }

    if (state.employeeID != null) {
      let zipcode = state.address?.zip_code
      let url = window.API_URL + "corporate/customers/" + state.employeeID + "/benefits/appointments/providers?company_id=" + sessionStorage.getItem('company_id')
      if (zipcode) {  url += `&pincode=${zipcode}` }
      window.axios.post(url, params)
        .then(function (response) {
          let providers = response.data?.providers?.sort((a, b) => {
            let aPriority = a.priority_pincodes?.includes(zipcode) ? a.priority : 1;
            let bPriority = b.priority_pincodes?.includes(zipcode) ? b.priority : 1;
            return bPriority - aPriority;
          }).sort((a, b) => (b.is_center_available - a.is_center_available))
          setSubState({ providers: providers, loading: false })
        })
        .catch(function (error) {
          handleAppError(error)
        })
    }
  }

  const previewAddress = `${state.address?.city}, ${state.address?.state}, ${state.address?.country}`

  const getTime = (hours) => {
    let newHh = hours
    if (hours === '12') {
      newHh = '12'
    } else if (hours === "01") {
      newHh = '13'
    } else if (hours === "02") {
      newHh = '14'
    } else if (hours === "03") {
      newHh = '15'
    } else if (hours === "04") {
      newHh = '16'
    } else if (hours === "05") {
      newHh = '17'
    } else if (hours === "06") {
      newHh = '18'
    } else if (hours === "07") {
      newHh = '19'
    } else if (hours === "08") {
      newHh = '20'
    } else if (hours === "09") {
      newHh = '21'
    }
    return newHh
  }

  const createAppointment = () => {
    setSubState({disableButton: true})
    let ids = []
    ids.push(state.packageID)

    let customer = {
      customer_id: state.employeeID,
      name: state.employeeName,
      package_ids: ids,
      addon_package_ids: [],
      is_main_customer: true,
      relation: 'me',
      benefit_type: state.benefitType
    };

    let customerParams = []
    customerParams.push(customer)

    const params = {
      booking_requests: [
        {
          home_collection_enable: state.packageType === 'home_collection',
          benefit_type: state.benefitType,
          deduction_type: 'cash_wallet',
          provider_id: state.selectedProviderID,
          mobile_number: state.mobileNumber,
          isd_code: state.isdCode,
          appointment_date: state.selectedDate,
          appointment_time: state.selectedTime,
          house_number: state.line1 || state.address.line1,
          address_one: state.line1 || state.address.line1,
          address_two: state.address.line2,
          city: state.address.city,
          state: state.address.state,
          country: state.address.country,
          zip_code: state.address.zip_code,
          latitude: state.address.latitude,
          longitude: state.address.longitude,
          customers: customerParams,
          type: 'appointment',
          source: 'datasense'
        }
      ],
      company_id: sessionStorage.getItem('company_id')
    }
    if (state.employeeID != null) {
      let url = window.API_URL + "corporate/customers/" + state.employeeID + "/benefits/appointments"
      setSubState({ loading: false });
      window.axios.post(url, params
      )
        .then(function (response) {
          createHandler(state.selectedProvider, state.selectedDate, response.data?.appointment_time ?? state.selectedTime, response.data?.booking_id, response.data?.unique_id )
          setSubState({disableButton: false})
        })
        .catch(function (error) {
          handleAppError(error)
          failureHandler()
          setSubState({disableButton: false})
        })
    }
  }

  const mapProviders = (providers) => {
    return providers.map((provider, index) => (
      <div key={provider.provider_id}>
        {Provider({ ...provider, index })}
      </div>
    ));
  };

  const Provider = (provider) => {
    let { serviceable, rating, is_center_available } = provider
    let ratingColor = '#d2d2d2'
    if (rating === '' || rating === null || rating === undefined) {
      ratingColor = '#d2d2d2'
    }
    else if (rating === 4) {
      ratingColor = '#3FCB7F'
    }
    else if (rating > 4) {
      ratingColor = '#2AB268'
    }
    else if (rating < 4 && rating > 3) {
      ratingColor = '#FFC72D'
    }
    else if (rating <= 3) {
      ratingColor = '#D1D5DB'
    }
    if ((showSlotsFor !== provider.index) && selected) {
      ratingColor = '#E5E8F0'
    }

    const renderDates = (provider) => {
      return (
        <Slots
          provider={provider}
          employeeID={state.employeeID}
          packageID={state.packageID}
          slotHandler={slotHandler}
          benefitType='ahc'
          address={state.address}
        />
      )
    }

    const slotHandler = (date, time, provider_id, provider) => {
      setSubState({ selectedProviderID: provider_id, selectedTime: time, selectedDate: date, selectedProvider: provider });
    }

    const toggleProviderSlots = () => {
      if ((showSlotsFor === provider.index) && selected) {
        setSelected(false)
      } else {
        setSlotsFor(provider.index)
        setSelected(true)
      }
    }

    return (
      <div className='border-b-2 border-gray-200 p-6 '>
        <div className={` flex justify-between  `}>
          <div>
            <div className={`font-semibold text-base ${provider.index !== showSlotsFor && selected ? 'text-gray-300' : 'text-gray-800'}`}>{provider.enterprise_name}</div>
            <div className={`text-sm ${provider.index !== showSlotsFor && selected ? 'text-gray-300' : 'text-gray-500'}`}>{`${provider.locality}, ${provider.city} ${provider.home_collection_enabled ? '' : '• ' + provider.estimated_distance}`}</div>
          </div>
          <div className='' >
            {provider.rating != null && <div className={`w-7 text-center text-sm rounded text-white`} style={{ backgroundColor: `${ratingColor}` }}>{provider.rating}</div>}
            <img src={arrow_tip_dark} alt='arrow-icon' className={`inline-block mt-2 p-2 cursor-pointer transform transition-colors ease-in-out duration-500 ${provider.index === showSlotsFor && selected ? 'rotate-180' : ''}`} onClick={() => { toggleProviderSlots() }} />
          </div>
        </div>
        {
          (provider.index === showSlotsFor && selected) && renderDates(provider)
        }
      </div>
    )
  }

  const renderNoProviderAvailable = () => {
    return (
      <EmptyListCard
        svgsrc={DCUnavailable}
        classes='mt-12'
        title='No diagnostic centre'
        subTitleClasses='w-72'
        subTitle='Sorry, our services are currently unavailable at this location, we look forward to serving you in the future.'
      />
    )
  }

  return (
    <div className='flex-col flex justify-between h-full bg-white' >
      <div className='bg-white'>
        <div className='flex justify-between py-4 px-6' style={{ background: '#F9FAFB' }}>
          <div className='flex justify-start items-center'>
            <img src={locationGrey} alt='location-icon' className='h-7' />
            <div className='px-4 font-semibold text-base text-gray-800'>{previewAddress}</div>
          </div>
          <button className={joinButtonClasses(dsButtonTextAction, 'px-2 text-sm')} onClick={(e) => changeHandler(e)}>Change<img src={blueArrow} className='inline-block ml-1' /></button>
        </div>
        { state.loading ? 
        <div className='flex justify-center items-center mt-20'>
          <SpinnerDotted classes='m-auto' />
        </div> :
        <>
        { state.providers.length > 0 ? mapProviders(state.providers): renderNoProviderAvailable() }
        </>
        }
      </div>
      <div className='bg-white h-20 flex justify-center sticky bottom-0 left-0' style={{ boxShadow: '0px -2px 10px #E5E8F0' }}>
        <button
          disabled={state.disableButton || state.selectedProviderID == null || state.selectedDate == null || state.selectedTime == null}
          onClick={() => createAppointment()}
          className={joinButtonClasses(
            dsButtonPrimary,
            'mx-3 my-4 h-11 w-full',
            (state.disableButton || state.selectedProviderID == null || state.selectedDate == null || state.selectedTime == null) && dsButtonDisabledPrimary
          )}
        >
          {state.disableButton ? <SpinnerDotted classes='h-5 ' /> : 'Book Appointment'}
        </button>
      </div>
    </div>
  )

}

export default ChooseProviderModal;
